import { popup } from '@tma.js/sdk';

export function showErrorPopup(title: string, message: string) {
    if (!popup.isSupported()) return;
    popup.show({ title, message, buttons: [{ id: 'ok', type: 'default', text: 'OK' }] });
}

export async function confirmAction(title: string, message: string): Promise<boolean> {
    if (!popup.isSupported()) return window.confirm(message);
    const result = await popup.show({
        title,
        message,
        buttons: [
            { id: 'cancel', type: 'cancel' },
            { id: 'confirm', type: 'destructive', text: title },
        ],
    });
    return result === 'confirm';
}
